import classes from "./FullPageLoader.module.css";

export function FullPageLoader({ message }: { message?: string }) {
  return (
    <div className={classes.container}>
      <div className={classes.spinner} />
      {message && <p>{message}</p>}
    </div>
  );
}
